import React from 'react';
import { useParams } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import ConceptCard from './ConceptCard';
import { useContent } from './contentContext';
import './learn.scss';

const TopicGrid = () => {
  const { topicId } = useParams<{ topicId: string }>();
  const { topics, concepts, loading, error } = useContent();

  if (loading) return <Typography>Loading…</Typography>;
  if (error) return <Typography color="error">Failed to load content: {error}</Typography>;

  const topic = topics.find((t) => t.id === topicId);
  const items = concepts.filter((c) => c.topic === topicId);

  if (!topic || items.length === 0) {
    return <Typography>No content yet for “{topicId}”.</Typography>;
  }

  return (
    <div className="topic-grid">
      <Typography variant="h4" component="h1" gutterBottom>
        {topic.title}
      </Typography>
      <div className="concept-list">
        {items.map((concept) => (
          <div className="concept-list-item" key={concept.id}>
            <ConceptCard concept={concept} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopicGrid;
